export enum WorkspaceLayoutConstants {
  SET_LAYOUT = "workspaceLayout/SET_LAYOUT",
  MERGE_LAYOUT = "workspaceLayout/MERGE_LAYOUT",
  SET_SYNCED_LAYOUT = "workspaceLayout/SET_SYNCED_LAYOUT",
  MERGE_SYNCED_LAYOUT = "workspaceLayout/MERGE_SYNCED_LAYOUT"
}
